// Square resolution is treated as portrait view
export const enum Orientation {
    LANDSCAPE,
    PORTRAIT,
}
